/* Matchday 26 theme scripts */
function toggleMenu(open){var m=document.getElementById('mobileMenu');if(m)m.classList.toggle('open',open);}

/* countdown to the final, July 19 2026 */
function tickCountdown(){
  var el=document.getElementById('countdown');if(!el)return;
  var target=new Date('2026-07-19T16:00:00Z').getTime(),d=Math.max(0,target-Date.now());
  var days=Math.floor(d/864e5);d-=days*864e5;
  var h=Math.floor(d/36e5);d-=h*36e5;
  var m=Math.floor(d/6e4);d-=m*6e4;
  var s=Math.floor(d/1e3);
  function box(n,l){return '<div class="cd-box"><div class="num">'+String(n).padStart(2,'0')+'</div><div class="lab">'+l+'</div></div>';}
  el.innerHTML=box(days,'Days')+box(h,'Hrs')+box(m,'Min')+box(s,'Sec');
}

/* reveal on scroll */
function revealInit(){
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
  document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
}

/* modern 2026 inspired ball texture (lighter 512x256) */
function makeModernBallTexture(){
  var W=512,H=256,cv=document.createElement('canvas');cv.width=W;cv.height=H;
  var ctx=cv.getContext('2d'),img=ctx.createImageData(W,H);
  var cols=[[206,32,46],[22,160,74],[40,92,200]];
  for(var y=0;y<H;y++){
    var th=y/H*Math.PI;
    for(var x=0;x<W;x++){
      var ph=x/W*Math.PI*2;
      var warp=1.7*Math.sin(2*ph+th*2.0)+2.0*Math.sin(th*1.6);
      var F=Math.sin(3*ph+warp);
      var F2=Math.sin(5*ph-warp*0.7+th*1.2);
      var r=242,g=244,b=238;
      var selRaw=(Math.sin(ph+th*2.2)+1)/2;
      var ci=Math.min(2,Math.floor(selRaw*3)),c=cols[ci];
      if(Math.abs(F)<0.34){
        var t=1-Math.abs(F)/0.34,mm=0.2+0.8*Math.min(1,t*1.5);
        r=Math.round(242*(1-mm)+c[0]*mm);g=Math.round(244*(1-mm)+c[1]*mm);b=Math.round(238*(1-mm)+c[2]*mm);
      }else if(Math.abs(F2)<0.13){
        var c2=cols[(ci+1)%3];
        r=Math.round(242*0.35+c2[0]*0.65);g=Math.round(244*0.35+c2[1]*0.65);b=Math.round(238*0.35+c2[2]*0.65);
      }
      var idx=(y*W+x)*4;
      img.data[idx]=r;img.data[idx+1]=g;img.data[idx+2]=b;img.data[idx+3]=255;
    }
  }
  ctx.putImageData(img,0,0);
  var tex=new THREE.CanvasTexture(cv);tex.anisotropy=2;return tex;
}
function init3D(){
  var canvas=document.getElementById('ball-canvas');if(!canvas||!window.THREE)return;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var renderer=new THREE.WebGLRenderer({canvas:canvas,alpha:true,antialias:true,powerPreference:'low-power'});
  var scene=new THREE.Scene();
  var cam=new THREE.PerspectiveCamera(45,1,.1,100);cam.position.set(0,0,5.6);
  function resize(){var w=canvas.clientWidth,h=canvas.clientHeight;renderer.setSize(w,h,false);renderer.setPixelRatio(Math.min(1.5,devicePixelRatio));cam.aspect=w/h;cam.updateProjectionMatrix();}
  var geo=new THREE.SphereGeometry(1.78,48,48);
  var mat=new THREE.MeshStandardMaterial({map:makeModernBallTexture(),roughness:.36,metalness:.08});
  var ball=new THREE.Mesh(geo,mat);ball.rotation.x=.32;scene.add(ball);
  scene.add(new THREE.AmbientLight(0xffffff,.7));
  var key=new THREE.DirectionalLight(0xffffff,1.2);key.position.set(4,5,6);scene.add(key);
  var lime=new THREE.PointLight(0xc9ff3a,.55,30);lime.position.set(-5,2,-2);scene.add(lime);
  var fill=new THREE.PointLight(0xffffff,.4,30);fill.position.set(4,-4,3);scene.add(fill);
  resize();window.addEventListener('resize',resize);
  /* pause animation when the ball is not on screen */
  var visible=true;
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){visible=es[0].isIntersecting;},{threshold:0}).observe(canvas);
  }
  var t=0;
  function loop(){
    requestAnimationFrame(loop);
    if(!visible)return;
    if(!reduce){t+=.005;ball.rotation.y+=.006;ball.position.y=Math.sin(t*1.6)*.12;}
    renderer.render(scene,cam);
  }
  loop();
}

/* lightweight bits run early */
document.addEventListener('DOMContentLoaded',function(){
  tickCountdown();setInterval(tickCountdown,1000);
  revealInit();
});

/* heavy 3D loads only after the page is ready, so it never blocks first paint */
function start3D(){if(window.__ball3d)return;window.__ball3d=1;init3D();}
function schedule3D(){(window.requestIdleCallback||function(cb){setTimeout(cb,250);})(start3D);}
if(document.readyState==='complete')schedule3D();
else window.addEventListener('load',schedule3D);
